import { Grid, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Backbutton from "assets/backbutton";
import { ReactComponent as CopyLink } from "assets/copy_link.svg";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import FileAdd from "assets/fileAdd";
import { ReactComponent as TimeClockCircle } from "assets/TimeClockCircle.svg";
import ThemeContext from "components/app/Context";
import CloseButton from "components/common/CloseButton";
import Feedback from "components/common/Feedback";
import Input from "components/common/Input";
import KebabMenu from "components/common/KebabMenu";
import ButtonLink from "components/common/Link";
import RichText from "components/common/RichText";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import MyPlanActionDetail from "components/features/ActionCardDetails/MyPlanActionDetail";
import { copyActionAsync, updateMyPlanCardDetailAsync } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import Resources from "components/features/Resources";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { ABOVE_PROPERTY, accessTypes, brandDeadLine, FEEDBACK_TIMER, messageTypes } from "utils/CommonConstants";
import { getHoursAndMin, getOwnersList, getUserHltId, matchOwnerWithHltId, matchPlanType } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { planTypes } from "utils/Types";
import { REDIRECT_URI } from "utils/URLConstants";
import Button from "../../common/Button";
import Basictabs from "../../common/Tabs";
import ActionCardDialogsContext from "../ActionCard/Context";
import Index from "../CardDialog";
import { TabsConfig } from "../CardDialog/TabsConfig";
import UpdateStatusConfirmDialog from "../planDetails/UpdateStatusConfirmationDialog";
import ActionButtons from "./ActionButtons";

export default function ActionDetailsDialog(props: any) {
  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const { activeActionCard: activeCard }: any = useAppSelector((state: any) => state.app);
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const isRedirectFromNotification: any = useAppSelector((state) => state.myPlanDetails.isRedirectFromNotification);
  const { isEdit, open, handleClose, assigneeList, isNew, isPreview = false, setShowPreview } = props;
  const restrictPlanType = useAppSelector((state) => state.myPlanDetails.myPlanDetails.planType);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);

  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;
  const [headerHeight, setHeaderHeight] = useState<number>(0);
  const location = useLocation();
  const titleRef: any = useRef();

  //TODO: will consider for refactor
  useEffect(() => {
    if (open || isEdit) {
      const height = titleRef.current?.clientHeight;
      setHeaderHeight(height);
    }
  }, [open, isEdit]);

  let {
    planId,
    planType = isNew ? planTypes.MyPlans : planTypes.AllPlans,
    sectionId,
    name,
    timeEstimateMinutes,
    id,
    linkToResources,
    body: cardBody
  } = activeCard || {};

  const methods = useForm({
    defaultValues: {
      name,
      timeEstimateMinutes,
      linkToResources: linkToResources || [{ title: "", url: "" }]
    }
  });

  const {
    register,
    formState: { errors }
  } = methods;

  const [body, setBody] = useState(cardBody);
  const [assigneeVal, setAssigneeVal] = useState();
  const [isCopyLinkSuccess, setIsCopyLinkSuccess] = useState(false);
  const { isMobileScreen } = useContext(ThemeContext);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [updatePayload, setUpdatePayload] = useState<any>();
  const {
    setIsOpenEditActionDialog,
    setIsOpenCopyActionDialog,
    setIsOpenViewActionDialog,
    setIsOpenDeleteActionDialog,
    setIsOpenPlanDetaiLDialog
  } = useContext(ActionCardDialogsContext);

  const getMenuOptions = () => {
    return planType === planTypes.MyPlans
      ? [
          {
            label: "Edit Action",
            icon: EditIcon,
            accessType: accessTypes.update,
            enabled: true,
            action: () => {
              if (matchPlanType(restrictPlanType) && activeCard?.cardEditable === "N") {
                dispatch(
                  setFeedbackDetails({
                    shouldShow: true,
                    type: "action",
                    setState: setFeedbackDetails({ shouldShow: false }),
                    actionType: "edit",
                    messageType:
                      restrictPlanType === brandDeadLine ? messageTypes.deadlinePlan : messageTypes.initiativePlan
                  })
                );
                return;
              }

              setIsOpenEditActionDialog(true);
            }
          },
          {
            label: "Delete Action",
            icon: DeleteIcon,
            accessType: accessTypes.delete,
            enabled: true,
            action: () => {
              if (!isAdmin && !matchOwnerWithHltId(selectedMyPlanDetail?.owners)) {
                dispatch(
                  setFeedbackDetails({
                    shouldShow: true,
                    type: "action",
                    displayName: getOwnersList(),
                    setState: setFeedbackDetails({ shouldShow: false }),

                    messageType:
                      selectedMyPlanDetail?.owners.length > 1 ? messageTypes.multipleOwners : messageTypes.singleOwner
                  })
                );
                return;
              } else if (matchPlanType(restrictPlanType) && activeCard?.cardEditable === "N") {
                dispatch(
                  setFeedbackDetails({
                    shouldShow: true,
                    type: "action",
                    setState: setFeedbackDetails({ shouldShow: false }),
                    actionType: "delete",
                    messageType:
                      restrictPlanType === brandDeadLine ? messageTypes.deadlinePlan : messageTypes.initiativePlan
                  })
                );
                return;
              }
              setIsOpenViewActionDialog(false);
              setIsOpenDeleteActionDialog(true);
            }
          }
        ]
      : [
          {
            label: "Copy shareable link",
            icon: CopyLink,
            action: () => {
              const link = planId
                ? REDIRECT_URI + "/plandetails/" + planId + "/" + sectionId + "/" + id + "?isshareable=true"
                : REDIRECT_URI + "/library/search?q=&cardid=" + id;
              navigator.clipboard.writeText(link).then(function () {
                setIsCopyLinkSuccess(true);
              });
              setIsCopyLinkSuccess(false);
            },
            enabled: true
          }
        ];
  };

  const onCopyActionClick = () => {
    setIsOpenCopyActionDialog(true);
    setIsOpenViewActionDialog(false);
  };

  const getDialogTitle = () => {
    return (
      <>
        <Feedback
          form=""
          actionStatus={{ shouldShow: isCopyLinkSuccess, variant: "success", timer: FEEDBACK_TIMER }}
          message="Link Copied"
        />
        <Grid container display="flex" spacing={2}>
          {isTemplatePlan && !isMobileScreen && (
            <Grid item xs={12}>
              <CloseButton
                handleClose={() => {
                  if (planType === planTypes.MulipleAssign) setIsOpenPlanDetaiLDialog(true);
                  handleClose();
                }}
              />
            </Grid>
          )}
          {isEdit || isNew ? (
            <>
              {isMobileScreen && (
                <Grid item xs={12}>
                  <CloseButton
                    handleClose={() => {
                      if (planType === planTypes.MulipleAssign) setIsOpenPlanDetaiLDialog(true);
                      handleClose();
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                {
                  <Typography variant="h4" showBold color={tokens.Text.General.PrimaryHeadline}>
                    {isNew && translate("myPlan.createNewAction")} {isEdit && translate("myPlan.editAction")}
                  </Typography>
                }
                <Input
                  label="Title"
                  placeholder="Add a brief title"
                  value={isNew ? "" : name}
                  register={register}
                  name="name"
                  validations={{ required: true }}
                  error={errors?.name}
                />
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="flex-end">
                <Input
                  type="text"
                  numeric
                  label="Duration (in mins)"
                  startAdornment={<TimeClockCircle />}
                  value={isNew ? "" : timeEstimateMinutes}
                  register={register}
                  validations={{
                    required: true,
                    min: 0,
                    max: 9999
                  }}
                  error={errors?.timeEstimateMinutes}
                  name="timeEstimateMinutes"
                />
              </Grid>
            </>
          ) : (
            <>
              {isPreview ? (
                <Grid item xs={12} onClick={() => setShowPreview(false)}>
                  <IconButton sx={{ paddingRight: "0", marginLeft: "-12px" }} onClick={handleClose}>
                    <Backbutton color={tokens.Icon.General.Color} />
                  </IconButton>
                  <ButtonLink
                    text="Back"
                    textVariant={"body2"}
                    underline="none"
                    sx={{
                      fontWeight: "700"
                    }}
                  ></ButtonLink>
                </Grid>
              ) : (
                <>
                  {((planType === planTypes.MyPlans && isMobileScreen) ||
                    planType === planTypes.AllPlans ||
                    planType === planTypes.MulipleAssign) && (
                    <Grid item xs={12} marginTop={isImpersonated && isMobileScreen ? "108px" : ""}>
                      <CloseButton
                        handleClose={() => {
                          if (planType === planTypes.MulipleAssign) setIsOpenPlanDetaiLDialog(true);
                          handleClose();
                        }}
                      />
                    </Grid>
                  )}
                </>
              )}

              <Grid item xs={12} md={10} marginTop={isMobileScreen ? "60px" : "66px"}>
                <Typography color={tokens.Text.General.PrimaryHeadline} variant="h5" showBold>
                  {name}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={2}
                display="flex"
                justifyContent={isMobileScreen ? "space-between" : "space-around"}
                alignItems={"center"}
                marginTop={isMobileScreen ? "60px" : "66px"}
              >
                <Timing duration={getHoursAndMin(timeEstimateMinutes)} />
                {!isPreview && <KebabMenu options={getMenuOptions()} />}
              </Grid>

              {!isPreview && (
                <>
                  <Grid item xs={12} display="flex" sx={{ flexDirection: { xs: "column", sm: "row" } }}>
                    <Grid item xs={12} sm={6} paddingTop={2} sx={{ xs: { justifyContent: "flex-end" } }}>
                      {(activeCard?.deadlineDate || activeCard.milestoneDate) && (
                        <>
                          <Typography component={"span"} variant={"body2"}>
                            Milestone for deadline:{" "}
                          </Typography>
                          <Typography component={"span"} variant={"body2"} showBold>
                            {getUIFormatDate(activeCard?.deadlineDate || activeCard.milestoneDate)}
                          </Typography>
                        </>
                      )}
                    </Grid>
                    {planType === planTypes.AllPlans && !isAdmin && !location?.state?.redirectFromDashboard && (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        paddingTop={2}
                        display="flex"
                        sx={{ justifyContent: { xs: "flex-start", sm: "flex-end" } }}
                      >
                        <Button
                          accessType={accessTypes.update}
                          variant="primary"
                          label="Copy Action to a plan"
                          startIcon={<FileAdd />}
                          onClick={onCopyActionClick}
                        />
                      </Grid>
                    )}
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </>
    );
  };

  const getDialogContent = () => {
    if (isPreview) return <Index />;
    if (isEdit || isNew) {
      return (
        <Grid
          container
          spacing={2}
          display="flex"
          flexDirection="column"
          sx={{
            overflow: "auto",
            display: "flex",
            flexDirection: "row"
          }}
        >
          <Grid item xs={12}>
            <Input
              register={register}
              name="summary"
              label="Summary"
              placeholder="Write a short summary"
              isMultiline={true}
              rowsCount={2}
              value={isNew ? "" : activeCard.summary}
            />
          </Grid>

          <Grid item xs={12}>
            <RichText
              label="Body"
              placeholder="Add the details in the body content"
              initialValue={isNew ? "" : activeCard.body}
              handleChangeUpdate={(data) => setBody(data)}
            />
          </Grid>
          <Grid item xs={12} paddingBottom={2}>
            <Resources label="Resources" />
          </Grid>
        </Grid>
      );
    }
    return (
      <Basictabs
        tabDetails={isTemplatePlan ? TabsConfig("TemplatePlan") : TabsConfig(planType)}
        alignItems="left"
        defaultTab={isRedirectFromNotification ? 1 : 0}
      />
    );
  };

  const onSubmit = (data: any) => {
    let tempData = data;
    if (tempData.linkToResources)
      tempData.linkToResources = tempData.linkToResources.filter((item: any) => item?.title !== "");
    tempData = {
      assignee: assigneeVal,
      body,
      ...tempData
    };

    if (isNew) {
      const cards = [];
      cards.push(tempData);
      const payload = { cards: cards };
      const url = { planId: planId, sectionId: sectionId };
      dispatch(copyActionAsync({ url, payload }));
      handleClose();
    } else {
      let payload;
      if (matchPlanType(restrictPlanType) && activeCard?.cardEditable === "N") {
        payload = {
          cards: [
            {
              status: tempData.status,
              assignee: tempData.assignee,
              priority: tempData.priority,
              targetedMetrics: tempData.targetedMetrics,
              dueDate: tempData.dueDate,
              id
            }
          ]
        };
      } else {
        payload = {
          cards: [
            {
              name: activeCard.name,
              id,
              ...tempData
            }
          ]
        };
      }

      const showConfirm =
        data?.status && activeCard.status !== data.status && !activeCard.assignee?.includes(getUserHltId());

      if (showConfirm) {
        setShowConfirmDialog(true);
        setUpdatePayload(payload);
      } else {
        dispatch(updateMyPlanCardDetailAsync({ url: `${planId}/sections/${sectionId}/cards`, payload }));
      }
    }
  };

  const handleUpdateAction = () => {
    dispatch(updateMyPlanCardDetailAsync({ url: `${planId}/sections/${sectionId}/cards`, payload: updatePayload }));
  };

  const handleCloseDialog = () => {
    setShowConfirmDialog(false);
  };

  return (
    <Dialog
      fullWidth={true}
      fullScreen={isMobileScreen}
      sx={isMobileScreen ? { paddingTop: "76px", zIndex: "5" } : {}}
      maxWidth={planType === planTypes.AllPlans || planTypes.MulipleAssign ? "md" : "lg"}
      open={open}
      onClose={(e, r) => {
        if (planType !== planTypes.MulipleAssign && r !== "backdropClick") handleClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disablePortal
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid container>
            <Grid
              sx={{ maxHeight: "88vh" }}
              xs={12}
              display="flex"
              id="dialogContainer"
              flexDirection={isMobileScreen ? "column" : "row"}
            >
              <Grid item xs={12} md={planType === planTypes.MyPlans && !isTemplatePlan ? 8 : 12} maxHeight="100%">
                <DialogTitle
                  id="alert-dialog-title"
                  sx={{
                    backgroundColor: tokens.Background.General.Color
                  }}
                  ref={titleRef}
                >
                  {getDialogTitle()}
                </DialogTitle>
                <DialogContent
                  id={isEdit || isNew ? "" : "actionPlanDialog"}
                  sx={{ height: `calc(100% - ${headerHeight}px)` }}
                >
                  {getDialogContent()}
                </DialogContent>
              </Grid>
              {planType === planTypes.MyPlans && !isTemplatePlan && (
                <MyPlanActionDetail
                  setAssigneeVal={setAssigneeVal}
                  assigneeList={assigneeList}
                  handleClose={handleClose}
                  isNew={isNew}
                  handleSubmit={methods.handleSubmit(onSubmit)}
                />
              )}
            </Grid>
            {(isNew || isEdit) && isTemplatePlan && (
              <Grid display="flex" justifyContent="end" width={"100%"}>
                <ActionButtons handleClose={handleClose} handleSubmit={methods.handleSubmit(onSubmit)} />
              </Grid>
            )}
          </Grid>
        </form>
      </FormProvider>

      <UpdateStatusConfirmDialog open={showConfirmDialog} onConfirm={handleUpdateAction} onClose={handleCloseDialog} />
    </Dialog>
  );
}
